import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api/axios';
import '../../styles/form.css';

const LoginForm = () => {
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError('');
  };

  const validateEmail = email => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  };

  const handleSubmit = async e => {
    e.preventDefault();

    const { email, password } = form;
    if (!email || !password) {
      setError('Completá todos los campos.');
      return;
    }

    if (!validateEmail(email)) {
      setError('El email no es válido.');
      return;
    }

    try {
      const res = await api.post('/users/login', form);
      const { token, user, business } = res.data;

      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('business', JSON.stringify(business));

      const slug = business.slug;

      if (user.role === 'ADMIN') {
        navigate(`/admin/${slug}`);
      } else if (user.role === 'MOZO') {
        navigate(`/mozo/${slug}/dashboard`);
      } else if (user.role === 'CAJERO') {
        navigate(`/cajero/${slug}/dashboard`);
      } else {
        setError('Rol no reconocido');
      }
    } catch (err) {
      const msg = err.response?.data?.message || 'Error al iniciar sesión';
      setError(msg);
      console.error('Error en login:', err);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h2>Iniciar sesión</h2>

      <input
        name="email"
        placeholder="Email"
        value={form.email}
        onChange={handleChange}
        required
      />
      <input
        name="password"
        type="password"
        placeholder="Contraseña"
        value={form.password}
        onChange={handleChange}
        required
      />

      {error && <p style={{ color: 'red' }}>{error}</p>}

      <button type="submit">Entrar</button>
    </form>
  );
};

export default LoginForm;
